import { render, staticRenderFns } from "./ToolbarLogo.vue?vue&type=template&id=324fd06a&scoped=true&lang=pug&"
import script from "./ToolbarLogo.vue?vue&type=script&lang=js&"
export * from "./ToolbarLogo.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarLogo.vue?vue&type=style&index=0&id=324fd06a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324fd06a",
  null
  
)

export default component.exports